import PlanPlaybookListView from './PlanPlaybookListView';
import PlanPlaybookDetailView from './PlanPlaybookDetailView';

const views = {
  PlanPlaybookDetailView,
  PlanPlaybookListView,
};

export default views;
